import { Form, Formik } from "formik";
import React, { useContext, useRef } from "react";
import { FormContext } from "../../../App";
import { FormContextMultiStepper } from "./MultiStepper";
import { FormContextSelfSchedulerStepper } from "../Self-Scheduler/SelfScheduler";
import * as yup from "yup";
import {
  Container,
  Paper
} from "@mui/material";

import Divider from "@mui/material/Divider";
import { styled } from "@mui/system";
import DataLayerService from "utility/dataLayerService";
import Validation from "utility/validation";
import TermOfServiceComponent from "components/atoms/TermOfService";
import TermAndCondition from "components/atoms/TermAndCondition";
import EmailInput from "components/atoms/EmailInput";
import SafetyLock from "components/atoms/SafetyLock";
import { LeafButton } from "components/atoms/LeafButtons";
import { useCountry, useComponentName, useProduct } from "hooks";
import ProgressBar from "components/atoms/ProgressBar";
import { scrollToTop, modalScrollToTop } from '../../../utility/functions';
import PostService from "utility/postService";

// SVG icons.
import { ReactComponent as TrustPilotIcon } from "components/Forms/form-icons/trust-pilot.svg";
import { ReactComponent as HomeAdvisorIcon } from "components/Forms/form-icons/home-advisor.svg";
import { ReactComponent as RemodellingIcon } from "components/Forms/form-icons/550-remodelling.svg";
import { ReactComponent as TestimonialIcon } from "components/Forms/form-icons/testimonial-icon.svg";
import { ReactComponent as TrustedIcon } from "components/Forms/form-icons/trusted-icon.svg";

const Email = (props) => {
  const location = props.dataSet?.location ? props.dataSet.location : "multi-step-modal-form";
  const form = props.dataSet?.form ? props.dataSet.form : "modal";
  const country = useCountry();
  const product = useProduct();
  const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);
  const additionalFormContext = (props.component === 'SelfScheduler' || props.modalComponent === 'SelfScheduler') ? FormContextSelfSchedulerStepper : FormContextMultiStepper;
  const { marketoData } = useContext(additionalFormContext);
  const userJourneyTracking = props.dataSet?.tracking || '';
  const componentName = props.component || 'ZipChecker';
  const formName = useComponentName(componentName);
  const subformName = useComponentName(props.modalComponent);
  const roofshape = props.dataSet?.roofshape ? props.dataSet.roofshape : '';
  const servicetype = props.dataSet?.servicetype ? props.dataSet.servicetype : '';
  const formRef = useRef(null);
  const customertestimonial = props.dataSet?.customertestimonial ?? '';
  const brandpartnerlogos = props.dataSet?.brandpartnerlogos ?? '';
  const trustpilotlogo = props.dataSet?.trustpilotlogo ?? '';
  const secondEmailStep = props.dataSet?.secondemailstep ?? '';
  const splitNameEmailStep = props.dataSet?.splitnameemailstep ?? '';

  let emailAddress = '';
  let emailOptIn = false;

  const ValidationSchema = yup.object().shape({
    emailAddress: yup
      .string()
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Email Address is not valid.')
      .required("Email Address is required."),
  });

  const buttonSubmit = (e) => {
    const EmailValidation = Validation.EmailDataLayerValidation(emailAddress);
    const TermsOfServiceValidation = Validation.TermsOfServiceDataLayerValidation(emailOptIn, country);

    // Validation Error.
    const validationError = {
      ...EmailValidation,
      ...TermsOfServiceValidation
    };

    if (Object.keys(validationError).length !== 0) {
      DataLayerService.formFailEvent(form, location, validationError);

      modalScrollToTop(props.modalComponent);
    }

    // Scroll to the Top.
    scrollToTop(formRef);
  }

  const handleOnBlur = (event) => {
    switch (event.target.name) {
      case 'emailAddress':
        emailAddress = event.target.value;
        break;

      default:
        break;
    }

    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent(form, location);
  };

  const StyledFormContainer = styled(Paper)(({ theme }) => ({
    background: "#ffffff",
    padding: `${theme.spacing(2)}`,
    borderRadius: 8,
    width: "100%",
    height: "auto",
  }));

  let email = '';
  if (marketoData !== undefined && marketoData !== null) {
    email = marketoData.email ? marketoData.email : '';
  }

  return (
    <Formik
      initialValues={{
        emailAddress: email
          ? email
          : '',
        termsOfService: false,
      }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        const { emailAddress } = values;

        const data = {
          ...formData,
          emailAddress: emailAddress,
        };

        let notes = '';

        if (props.component !== 'ShortLeadForm') {
          notes += `Home Levels: ${formData.homeLevel}\n` +
          `Home Size: ${formData.squareFootage} sq ft\n` +
          `Senior: ${(formData.groupLevel?.includes("senior") ? "Yes" : "No")}\n` +
          `Veteran: ${(formData.groupLevel?.includes("military") ? "Yes" : "No")}\n`;
        }

        notes += `txtSMSMarketingConsent: ${(country !== "ca" ? (values.txtSMSMarketingConsent ? "true" : "false") : "true")}\n` +
          `House Type: ${(formData.houseType !== undefined ? formData.houseType : "")}\n` +
          `Landing Page: ${window.location.href}`;

        if (formData.serviceType) {
          notes += `\nType of Service: ${formData.serviceType}`;
        }

        if (formData.roofShape) {
          notes += `\nShape of Roof: ${formData.roofShape}`;
        }

        try {
          const sfmcData = {
            "firstName": formData.firstName,
            "lastName": formData.lastName,
            "email": emailAddress,
            "postalCode": formData.zipCode,
            "country": country,
            "businessUnit": product,
            "notes": notes,
            "created": new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
            "productInterest": formData.serviceType
          };
          PostService.sendToSFMCAbandonment('sfmc-abandonment', sfmcData);
        } catch (error) {
          console.log(error);
          console.log("Error in sending data");
        }

        setFormData(data);

        if (secondEmailStep === 'enable') {
          if (servicetype === 'enable') {
            setActiveStepIndex(1);
          }
          else if (roofshape === 'enable') {
            setActiveStepIndex(2);
          }
          else {
            setActiveStepIndex(3);
          }
        }
        else {
          if (splitNameEmailStep === 'enable') {
            setActiveStepIndex(5);
          }
          else {
            setActiveStepIndex(activeStepIndex + 1);
          }
        }

        // Scroll to the Top.
        scrollToTop(formRef);

        if (userJourneyTracking) {
          let stepNumber;
          if (activeStepIndex === 'email') {
            stepNumber = 6;
          }
          else {
            stepNumber = activeStepIndex - 1;
            if (secondEmailStep === 'enable') {
              stepNumber = 2;
            }
            else {
              if (servicetype === 'enable') {
                stepNumber += 1;
              }
              if (roofshape === 'enable') {
                stepNumber += 1;
              }
            }
          }
          if ((componentName === 'ZipChecker') || (componentName === 'ModalForm')) {
            stepNumber += 1;
          }

          // Number of required Fields.
          let requiredFields = 3;
          if (country === 'ca') {
            requiredFields = 4;
          }
          // Passing lf.form.status event to DataLayer.
          DataLayerService.formStatusEvent(formName, subformName, product, stepNumber, requiredFields, 'notcompleted');
        }

        // Passing lf.form.start event to DataLayer.
        DataLayerService.formStartEvent(form, location, data);
      }}
    >
      {({ handleSubmit, isSubmitting, errors }) => (
        <Container maxWidth={"sm"} disableGutters={true}>
          <StyledFormContainer>
            <Form
              onSubmit={handleSubmit}
              ref={formRef}
              onBlur={
                (event) => { handleOnBlur(event) }
              }
            >
              {isSubmitting && Object.keys(errors).length > 0 && scrollToTop(formRef)}

              {trustpilotlogo === 'enable' && (
                <div className="trust-pilot-logo">
                  <a
                    href="https://www.trustpilot.com/review/www.leaffilter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Read our reviews on Trustpilot"
                  >
                    <TrustPilotIcon
                      alt="Trustpilot logo"
                    />
                  </a>
                </div>
              )}

              <div className="estimate-trust-section estimate-just-name">
                {/* Trusted Section */}
                <div className="estimate-trust-section__badge-row">
                  <div className="estimate-trust-section__icon">
                    <TrustedIcon alt="Trusted Icon" />
                  </div>
                  <div>
                    <h2 className="estimate-trust-section__text">
                      Trusted by 1,000,000+ Homeowners
                    </h2>
                  </div>
                </div>

                {/* Personalize Section */}
                <div>
                  <h2 className="estimate-trust-section__personalize-text">
                    Just a few more details.
                  </h2>
                </div>
              </div>

              {brandpartnerlogos === 'enable' && (
                <div className="badge-container">
                  {/* Remodeling Badge */}
                  <div className="badge">
                    <RemodellingIcon
                      alt="550 Remodeling logo"
                    />
                  </div>

                  {/* HomeAdvisor Badge */}
                  <div className="badge">
                    <HomeAdvisorIcon
                      alt="HomeAdvisor Screened and Approved"
                    />
                  </div>

                  {/* Trustpilot Badge */}
                  <div className="badge">
                    <a
                      href="https://www.trustpilot.com/review/www.leaffilter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Read our reviews on Trustpilot"
                    >
                      <TrustPilotIcon
                        alt="Trustpilot logo"
                      />
                    </a>
                  </div>
                </div>
              )}

              {customertestimonial === 'top' && (
                <div className="testimonial">
                  <div className="testimonial-content">
                    <p className="quote">
                      “The estimator made us extremely confident about LeafFilter from the very beginning.”
                    </p>
                    <div className="rating-location">
                      <span className="stars" aria-label="5 out of 5 stars" role="img">★★★★★</span>
                    </div>
                  </div>
                  <div className="testimonial-photo">
                    <TestimonialIcon alt="Photo of happy LeafFilter customer from FL" />
                  </div>
                </div>
              )}

              <EmailInput fieldName={'emailAddress'} />
              <Divider className="divider" />

              {country === 'ca' ? (
                <TermOfServiceComponent />
              ) : ''}

              <LeafButton
                buttonType={"primary"}
                type="submit"
                handleClick={() => buttonSubmit()}
                isSubmitting={isSubmitting}
                style={{
                  width: "100%"
                }}
              >
                Next
              </LeafButton>
              <SafetyLock {...props} />
              <ProgressBar {...props} />

              {customertestimonial === 'bottom' && (
                <div className="testimonial">
                  <div className="testimonial-content">
                    <p className="quote">
                      “The estimator made us extremely confident about LeafFilter from the very beginning.”
                    </p>
                    <div className="rating-location">
                      <span className="stars" aria-label="5 out of 5 stars" role="img">★★★★★</span>
                    </div>
                  </div>
                  <div className="testimonial-photo">
                    <TestimonialIcon alt="Photo of happy LeafFilter customer from FL" />
                  </div>
                </div>
              )}
              <TermAndCondition />
            </Form>
          </StyledFormContainer>
        </Container>
      )}
    </Formik>
  );
}

export default Email;
